import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CalendarItem } from '../../../models/calendar.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { CalendarService } from '../../../services/calendar/calendar.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: []
})
export class CalendarComponent implements OnInit {
  noFilter: any;
  public calendarItems: CalendarItem[] = [];
  public calendarDialog = false;
  public newDataAvailable = false;
  public customFilter = KontableComponent.CustomFilter;
  modalTitle = '';
  labels = {};

  constructor(
    public srvCalendar: CalendarService,
    private translate: TranslateService
  ) { }

  ngOnInit() {

    this.translate.get([
      'calendarList.add_title',
      'calendarList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['calendarList.add_title'];
      this.labels['edit_title'] = res['calendarList.edit_title'];
    });

    this.translate.get(['calendarList']).subscribe((res) => {
      this.srvCalendar.getAll().subscribe(items => {
        this.calendarItems = items;
      });
    });
  }

  refresh() {
    this.translate.get(['calendarList']).subscribe((res) => {
      this.srvCalendar.getAll().subscribe(items => {
        this.calendarItems = items;
        this.newDataAvailable = true;
      });
    });
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    console.log(this.srvCalendar.calendarEditing);

    this.srvCalendar.calendarEditing = ((data == null) ? {} : data);
    this.calendarDialog = true;
  }

  delete (record): void {
    this.srvCalendar.delete(record).subscribe(() => {
      this.refresh();
    });
  }


  calendarAdded($event): void {
    this.srvCalendar.post($event).subscribe(() => {
      this.srvCalendar.calendarEditing = null;
      this.calendarDialog = false;
      this.refresh();
    });

  }

  calendarUpdated($event): void {
    this.srvCalendar.put($event).subscribe(() => {
        this.srvCalendar.calendarEditing = null;
        this.calendarDialog = false;
        this.refresh();
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar/calendar.component.ts